import { useState, useEffect } from 'react';
import { AdminService } from '../../../../core/services/AdminService';

interface Props {
    idSelector: number;
    onChange: any;
}

export const SelectorAplication = ({ idSelector, onChange }: Props) => {

    const service = new AdminService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(null);

    useEffect(() => {
        getLista();
    }, [])

    useEffect(() => {
        onChange(id);
    }, [id])

    // useEffect(() => {

    //     if(idSelector != id)
    //         setID(idSelector);

    // }, [idSelector])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        service.getApplicationCatalog().subscribe((resp: any) => {
            //console.log("Application", resp);
            if (resp.DataBeanProperties.ObjectValue) {
                setLista(resp.DataBeanProperties.ObjectValue);
            }
        });
    };

    return (
        <>
            <label className='mb-2'>Tipo de Aplicación</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={0}>...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.IDApplication} value={item.DataBeanProperties.IDApplication} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}
